<div *ngIf="observation.component.length > 1 && observation.name" class="parent-label">
  {{ observation.name }}
</div>
<div>
  <div class="component-row" *ngFor="let component of observation.component">
    <span class="component-label">{{ component.name }}</span>
    <div class="component-value-wrapper">
      <mat-icon *ngIf="component.device?.refaire" style="font-size: 20px" [matTooltip]="component.device?.reference"> bluetooth </mat-icon>
      <span
        [style]="component.normColor ? 'color:' + component.normColor : ''"
        *ngIf="!(component.device?.type === 'MIR' && component.valueArray?.length)"
      >
        <span class="component-value">{{ component.value + (component.unit ? " " + component.unit : "") }}</span>
      </span>
      <span *ngIf="component.device?.type === 'MIR' && component.valueArray?.length">
        <button mat-stroked-button type="button" (click)="showGraph(component)">
          {{ "knowledgebase.knowledgeCriteria.show" | translate }}
        </button>
      </span>
      <span *ngIf="component.effectiveTiming"> &nbsp;({{ component.effectiveTiming }}) </span>
      <span>
        <mat-icon *ngIf="component.valuePictures?.length > 0" class="pictureButton" (click)="showPictures(component)">
          camera_alt
        </mat-icon>
      </span>
      <span *ngFor="let alert of component.relatedAlerts ?? []">
        <mat-icon
          *ngIf="alert.level === RULE_LEVEL.MEDIUM || alert.level === RULE_LEVEL.HIGH"
          class="custom-icon-small"
          [ngClass]="[alert | alertLevelClass, alert.resultsPractitionner ? 'cursor-help' : '']"
          [matTooltip]="alert.resultsPractitionner ?? ''"
          >notifications</mat-icon
        >
      </span>
      <span>
        <mat-icon
          class="ml-05 pointer color-button"
          style="width: unset; height: unset"
          fontSet="fas"
          fontIcon="fa-history"
          *ngIf="observation.outdatedAlerts?.length"
          [matTooltip]="'dialog.alertsHistory.title' | translate"
          (click)="openAlertHistory(observation.outdatedAlerts)"
        ></mat-icon>
      </span>
    </div>
  </div>
</div>
